import { FC, PropsWithChildren } from "react";
import Text from "../Text";
import styles from "./styles.module.css";
import { ContractStatus, OrderStatus, OrderTypeEnumKeys, TaskStatus } from "@/types";

interface Props {
  status: OrderTypeEnumKeys | OrderStatus | ContractStatus | TaskStatus | undefined;
  onClick?: () => void;
}

const Tag: FC<PropsWithChildren<Props>> = ({ status, ...props }) => {
  if (!status) return null;
  const statusClass = status?.toLowerCase() as keyof typeof styles;

  return (
    <span className={`${styles.tagRoot} ${status ? styles[statusClass] : ""}`}>
      <Text size="xs" display="technical" tt="uppercase" {...props} />
    </span>
  );
};

export default Tag;
